/* import __COLOCATED_TEMPLATE__ from './credit-payment-history-modal.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { SH_GENERAL_INVOICE_TRANSACTION } from 'sh-www/models/sh-general-invoice-transaction';
import { closeModal, showNextModal } from 'sh-www/utils/modal-controls';
import { inject as service } from '@ember/service';

const CLASS_NAME = 'SH-c-reports-credit-payment-history-modal';

class ReportsAdminRecordPaymentModal extends Component {
  @service session;

  get className() {
    return CLASS_NAME;
  }

  get canDelete() {
    return this.session.currentUser.isAdmin
      && !this.args.model.shGeneralInvoice.isPaid;
  }

  get transactionMethodNamesMap() {
    return SH_GENERAL_INVOICE_TRANSACTION.PAYMENT_METHOD_NAMES;
  }

  @action
  handleDelete(shGeneralInvoiceTransaction) {
    const {
      loadCompanyCostCodeCreditsTask,
      loadCompanyCreditFactoidsTask,
      loadCreditDeletedInvoicesTask,
      loadCreditUnpaidInvoicesTask,
      updateCompanyCreditFactoids,
      updateCompanyCostCodeCredits,
      updateShGeneralDeletedInvoices,
      updateShGeneralUnpaidInvoices,
    } = this.args.model;

    // show success
    showNextModal(this, 'reports/delete-credit-transaction-modal-confirm', {
      shGeneralInvoiceTransaction,
      loadCompanyCostCodeCreditsTask,
      loadCompanyCreditFactoidsTask,
      loadCreditDeletedInvoicesTask,
      loadCreditUnpaidInvoicesTask,
      updateCompanyCreditFactoids,
      updateCompanyCostCodeCredits,
      updateShGeneralDeletedInvoices,
      updateShGeneralUnpaidInvoices,
    });
  }

  @action
  handleDismiss() {
    closeModal(this);
  }
}

export default ReportsAdminRecordPaymentModal;
